import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbCurrencyConverter = () => {
  return (
    <div
      className="ht__bradcaump__area__resource"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>Currency Converter</h1>
              <p>
                Instant, accurate, and real-time exchange rate conversions for
                over 100 currencies, all in one place.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Convert Now
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbCurrencyConverter.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbCurrencyConverter;
